import { STATUSPAGE } from '@repo/ui';
import { GetConsolidatedActivitiesByStudentUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { loadFilters } from 'presentation/config/store/reports/consolidated-activities-by-student-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { IConsolidatedActivitiesByStudentFilters } from '../models/consolidated-activities-by-student-filters';

export const useConsolidatedActivitiesByStudent = () => {
  //Hooks
  const { reportService } = useService();
  const dispatch = useDispatch();

  // States
  const { filters } = useAppSelector(
    (state) => state.consolidatedActivitiesByStudent,
  );
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<
    'export-pdf' | 'export-excel'
  >(null);

  // Methods
  const requestGetConsolidatedActivitiesByStudent = useCallback(
    async (
      params: GetConsolidatedActivitiesByStudentUseCaseInterface.Params,
    ) => {
      setLoading(STATUSPAGE.LOADING);
      await reportService
        .getConsolidatedActivitiesByStudent(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === 0 ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const saveFilters = useCallback(
    (params: IConsolidatedActivitiesByStudentFilters) => {
      dispatch(loadFilters(params));
    },
    [],
  );

  return {
    loading,
    selectedSubmitBtn,
    filters,
    setSelectedSubmitBtn,
    requestGetConsolidatedActivitiesByStudent,
    saveFilters,
  };
};
